// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthNav_list__bgO4h","item":"AuthNav_item__3xJnT","link":"AuthNav_link__3ent8"};